export default {
  name: 'transaction_customer_email',
  component_path: 'modules/procedures/blocks/BlockInputEmail',
  static_mandatory: ['required', 'email'],
  static_options: {
    autocomplete: 'email'
  }
}